__turbopack_context__.v({
  "body": "ProfileLocationInput-module-scss-module__weCq4G__body",
  "header": "ProfileLocationInput-module-scss-module__weCq4G__header",
  "hint": "ProfileLocationInput-module-scss-module__weCq4G__hint",
  "label": "ProfileLocationInput-module-scss-module__weCq4G__label",
  "root": "ProfileLocationInput-module-scss-module__weCq4G__root",
  "row": "ProfileLocationInput-module-scss-module__weCq4G__row",
});
